import React, { useState, useEffect } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { yearlyShareNOK } from '@api/analytics';
import { YearlyShareNOK } from '@typings/Analytics';
import { ApiResponse } from '@typings/ApiResponse';
import { ShareNOKChartData } from '../../types';

interface YearlyChartProps {
  partnerCarehomeId: string;
}

const YearlyChart: React.FC<YearlyChartProps> = ({ partnerCarehomeId }) => {
  const [yearlyData, setYearlyData] = useState<ShareNOKChartData[]>();
  useEffect(() => {
    const getYearlyData = async () => {
      try {
        const res: ApiResponse<YearlyShareNOK[]> =
          await yearlyShareNOK(partnerCarehomeId);
        if (res?.data) {
          const transformedData = res.data.map(item => {
            const { year, nextOfKin, total } = item;
            return {
              name: year.toString(),
              Shared: nextOfKin,
              'Not shared': total - nextOfKin,
            };
          });
          setYearlyData(transformedData);
        }
      } catch (error) {
        console.error('Error fetching yearly data:', error);
      }
    };
    if (partnerCarehomeId) {
      getYearlyData();
    }
  }, [partnerCarehomeId]);
  return (
    <div className="mb-10">
      <h3 className="govuk-heading-s chart-title">Years (2025 - 2034)</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={yearlyData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Shared" stackId="a" fill="#005eb8" />
          <Bar dataKey="Not shared" stackId="a" fill="#d4351c" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default YearlyChart;
